import React from "react";
import ReactDOM from "react-dom/client";
import App from "../App.tsx";

// The app waits on navigator.serviceWorker.ready before subscribing to push, so
// the worker has to be registered here. It is served from public/ to get the
// whole site as its scope.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
